<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <AlarmNoticeTableButton @notice='notice'></AlarmNoticeTableButton>
        <AlarmNoticeTable ref='alarmNoticeTable'></AlarmNoticeTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmNoticeTableButton from '../../components/alarmconfig/alarmNotice/AlarmNoticeTableButton';
import AlarmNoticeTable from '../../components/alarmconfig/alarmNotice/AlarmNoticeTable';

export default {
  name: 'AlarmNoticePage',
  components: {
    BasicLayout,
    AlarmNoticeTableButton,
    AlarmNoticeTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.alarmNotice')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'add':
          this.$refs.alarmNoticeTable.addFunc();
          break;
        case 'remove':
          this.$refs.alarmNoticeTable.removeFunc();
          break;
        case 'edit':
          this.$refs.alarmNoticeTable.editFunc();
          break;
        case 'refresh':
          this.$refs.alarmNoticeTable.getAlarmNoticeTableData();
          break;
        case 'able':
          this.$refs.alarmNoticeTable.updateStatusFunc('enable');
          break;
        case 'disable':
          this.$refs.alarmNoticeTable.updateStatusFunc('unenable');
          break;
        default:
      }
    }
  }
};
</script>